import { type PaymentStatus } from '@rematter/frontend-lib-api-client';
import { Badge } from '@rematter/ui-web';

import { useTranslations } from '../../i18n/useTranslations';
import { colorByPaymentStatus } from '../../utils';

type PaymentStatusBadgeProps = { status: PaymentStatus };

export const PaymentStatusBadge = ({ status }: PaymentStatusBadgeProps) => {
  const t = useTranslations();

  const statusKey = (
    status === 'VoidedWriteOff' ? 'voided' : status.toLowerCase()
  ) as keyof typeof t.payments.list.status.options;

  return (
    <Badge color={colorByPaymentStatus[status]} className="@PaymentStatusBadge">
      {t.payments.list.status.options[statusKey] ?? status}
    </Badge>
  );
};
